import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MinhaAreaLayout from "./layouts/MinhaAreaLayout";
import Home from "./pages/Home";
import SearchResults from "./pages/SearchResults";
import SaleSearchResults from "./pages/SaleSearchResults";
import PropertyDetails from "./pages/PropertyDetails";
import PropertySaleDetails from "./pages/PropertySaleDetails";
import Login from "./pages/Login";
import EntrarChoice from "./pages/EntrarChoice";
import CadastroChoice from "./pages/CadastroChoice";
import ResetPassword from "./pages/ResetPassword";
import Backoffice from "./pages/Backoffice";
import NewProperty from "./pages/NewProperty";
import Messages from "./pages/Messages";
import Terms from "./pages/Terms";
import FaleConosco from "./pages/FaleConosco";
import Sobre from "./pages/Sobre";
import Ajuda from "./pages/Ajuda";
import PartnerRegistration from "./pages/PartnerRegistration";
import Privacy from "./pages/Privacy";
import Sitemap from "./pages/Sitemap";
import NotFound from "./pages/NotFound";
import Favoritos from "./pages/Favoritos";
import MyBookings from "./pages/MyBookings";
import ChangePassword from "./pages/ChangePassword";
import OwnerBookings from "./pages/OwnerBookings";
import OwnerBookingsInner from "./pages/OwnerBookingsInner";
import OwnerProperties from "./pages/OwnerProperties";
import OwnerDocuments from "./pages/OwnerDocuments";
import EditProfile from "./pages/EditProfile";
import Policy from "./pages/Policy";
import ManageAvailability from "./pages/ManageAvailability";
import Notifications from "./pages/Notifications";
import PartnerDetails from "./pages/PartnerDetails";
import PartnerSearch from "./pages/PartnerSearch";
import AdminUsers from "./pages/AdminUsers";
import AdminProperties from "./pages/AdminProperties";
import AdminPartners from "./pages/AdminPartners";
import AdminDevelopments from "./pages/AdminDevelopments";
import AdminResorts from "./pages/AdminResorts";
import AdminBookings from "./pages/AdminBookings";
import AdminContacts from "./pages/AdminContacts";
import AdminDashboard from "./pages/AdminDashboard";
import AdminEditUser from "./pages/AdminEditUser";
import AdminNewUser from "./pages/AdminNewUser";
import AdminViewUser from "./pages/AdminViewUser";
import AdminEditPartner from "./pages/AdminEditPartner";
import AdminEditDevelopment from "./pages/AdminEditDevelopment";
import AdminDevelopmentFaq from "./pages/AdminDevelopmentFaq";
import AdminEditProperty from "./pages/AdminEditProperty";
import AdminViewBooking from "./pages/AdminViewBooking";
import AdminBanners from "./pages/AdminBanners";
import AdminLogin from "./pages/AdminLogin";
import VouchersPage from "./pages/VouchersPage";
import PartnerLandingPage from "./pages/PartnerLandingPage";
import PartnerParadisePage from "./pages/PartnerParadisePage";
import Porto2Life from "./pages/Porto2Life";
import ExclusiveGramado from "./pages/ExclusiveGramado";
import PyreneusResidence from "./pages/PyreneusResidence";
import ExclusiveGavResorts from "./pages/ExclusiveGavResorts";
import PremiumGavResorts from "./pages/PremiumGavResorts";
import SanteVivreExperience from "./pages/SanteVivreExperience";
import WanderlustExperience from "./pages/WanderlustExperience";
import AssinarLive from "./pages/AssinarLive";
import MinhaAssinatura from "./pages/MinhaAssinatura";
import AssinaturaConfirmada from "./pages/AssinaturaConfirmada";
import UserArea from "./pages/UserArea";
import ResortDetails from "./pages/ResortDetails";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/busca" element={<SearchResults />} />
          <Route path="/venda" element={<SaleSearchResults />} />
          <Route path="/imovel/:id" element={<PropertyDetails />} />
          <Route path="/imovel-venda/:id" element={<PropertySaleDetails />} />
            <Route path="/parceiro/:id" element={<PartnerDetails />} />
            <Route path="/parceiro" element={<PartnerSearch />} />
            <Route path="/parceiros" element={<PartnerSearch />} />
          <Route path="/entrar" element={<EntrarChoice />} />
          <Route path="/cadastro" element={<CadastroChoice />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/mensagens" element={<Messages />} />
          <Route path="/termos" element={<Terms />} />
          <Route path="/fale-conosco" element={<FaleConosco />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/ajuda" element={<Ajuda />} />
          <Route path="/cadastro-parceiro" element={<PartnerRegistration />} />
          <Route path="/privacidade" element={<Privacy />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/politica" element={<Policy />} />
          <Route path="/vouchers" element={<VouchersPage />} />
          <Route path="/lp/parceiros" element={<PartnerLandingPage />} />
          <Route path="/lp/paradise" element={<PartnerParadisePage />} />
          <Route path="/empreendimentos/porto-2-life" element={<Porto2Life />} />
          <Route path="/empreendimentos/exclusive-gramado" element={<ExclusiveGramado />} />
          <Route path="/empreendimentos/pyreneus-residence" element={<PyreneusResidence />} />
          <Route path="/empreendimentos/exclusive-gav-resorts" element={<ExclusiveGavResorts />} />
          <Route path="/empreendimentos/premium-gav-resorts" element={<PremiumGavResorts />} />
          <Route path="/empreendimentos/sante-vivre-experience" element={<SanteVivreExperience />} />
          <Route path="/empreendimentos/wanderlust-experience" element={<WanderlustExperience />} />
          <Route path="/resorts/:slug" element={<ResortDetails />} />
          <Route path="/reservas-proprietario" element={<OwnerBookings />} />
          <Route path="/minha-assinatura" element={<AssinaturaConfirmada />} />
          <Route path="/minha-area" element={<MinhaAreaLayout />}>
            <Route index element={<UserArea />} />
            <Route path="reservas" element={<MyBookings />} />
            <Route path="solicitacoes-reservas" element={<OwnerBookingsInner />} />
            <Route path="favoritos" element={<Favoritos />} />
            <Route path="mensagens" element={<Messages />} />
            <Route path="notificacoes" element={<Notifications />} />
            <Route path="cadastro" element={<EditProfile />} />
            <Route path="senha" element={<ChangePassword />} />
            <Route path="meus-imoveis" element={<OwnerProperties />} />
            <Route path="novo-imovel" element={<NewProperty />} />
            <Route path="editar-imovel/:id" element={<NewProperty />} />
            <Route path="gerenciar-disponibilidade" element={<ManageAvailability />} />
            <Route path="documentos" element={<OwnerDocuments />} />
            <Route path="assinar-live" element={<AssinarLive />} />
            <Route path="minha-assinatura" element={<MinhaAssinatura />} />
            <Route path="admin/usuarios" element={<AdminUsers />} />
            <Route path="admin/usuarios/novo" element={<AdminNewUser />} />
            <Route path="admin/usuarios/visualizar/:id" element={<AdminViewUser />} />
            <Route path="admin/usuarios/editar/:id" element={<AdminEditUser />} />
            <Route path="admin/imoveis" element={<AdminProperties />} />
            <Route path="admin/imoveis/editar/:id" element={<AdminEditProperty />} />
            <Route path="admin/parceiros" element={<AdminPartners />} />
            <Route path="admin/parceiros/novo" element={<AdminEditPartner />} />
            <Route path="admin/parceiros/editar/:id" element={<AdminEditPartner />} />
            <Route path="admin/resorts" element={<AdminResorts />} />
            <Route path="admin/empreendimentos" element={<AdminDevelopments />} />
            <Route path="admin/empreendimentos/novo" element={<AdminEditDevelopment />} />
            <Route path="admin/empreendimentos/editar/:id" element={<AdminEditDevelopment />} />
            <Route path="admin/empreendimentos/:id/faq" element={<AdminDevelopmentFaq />} />
            <Route path="admin/contatos" element={<AdminContacts />} />
            <Route path="admin/reservas" element={<AdminBookings />} />
            <Route path="admin/reservas/visualizar/:id" element={<AdminViewBooking />} />
            <Route path="admin/dashboard" element={<AdminDashboard />} />
            <Route path="admin/banners" element={<AdminBanners />} />
          </Route>
          
          {/* Rotas Administrativas Separadas */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/usuarios" element={<AdminUsers />} />
          <Route path="/admin/usuarios/novo" element={<AdminNewUser />} />
          <Route path="/admin/usuarios/visualizar/:id" element={<AdminViewUser />} />
          <Route path="/admin/usuarios/editar/:id" element={<AdminEditUser />} />
          <Route path="/admin/imoveis" element={<AdminProperties />} />
          <Route path="/admin/imoveis/editar/:id" element={<AdminEditProperty />} />
          <Route path="/admin/parceiros" element={<AdminPartners />} />
          <Route path="/admin/parceiros/novo" element={<AdminEditPartner />} />
          <Route path="/admin/parceiros/editar/:id" element={<AdminEditPartner />} />
          <Route path="/admin/resorts" element={<AdminResorts />} />
          <Route path="/admin/empreendimentos" element={<AdminDevelopments />} />
          <Route path="/admin/empreendimentos/novo" element={<AdminEditDevelopment />} />
          <Route path="/admin/empreendimentos/editar/:id" element={<AdminEditDevelopment />} />
          <Route path="/admin/empreendimentos/:id/faq" element={<AdminDevelopmentFaq />} />
          <Route path="/admin/contatos" element={<AdminContacts />} />
          <Route path="/admin/reservas" element={<AdminBookings />} />
          <Route path="/admin/reservas/visualizar/:id" element={<AdminViewBooking />} />
          <Route path="/admin/banners" element={<AdminBanners />} />
          
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
